import {
    createVNode as _$cv,
    className as _$cn,
} from 'intact';
import {getRestProps} from '../utils';
import {makeButtonGroupStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, vertical, children, fluid} = this.get();
    
    const classNameObj = {
        'k-btns': true,
        'k-vertical': vertical,
        'k-fluid': fluid,
        [className]: className,
        [makeButtonGroupStyles()]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, children);
};